import { render, staticRenderFns } from "./register-company.vue?vue&type=template&id=e6c4109a&scoped=true&"
import script from "./register-company.vue?vue&type=script&lang=js&"
export * from "./register-company.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=e6c4109a&scoped=true&lang=css&"
import style1 from "@/assets/sass/home.css?vue&type=style&index=1&id=e6c4109a&scoped=true&lang=css&"
import style2 from "./register.scss?vue&type=style&index=2&id=e6c4109a&scoped=true&lang=scss&"
import style3 from "./register-company.vue?vue&type=style&index=3&id=e6c4109a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c4109a",
  null
  
)

export default component.exports